export const StripeConfig = {
  key: process.env.STRIPE_PUBLISHABLE_KEY,
  isProduction: process.env.STRIPE_ENV === 'production'
};

export const AppConfig = {
  DOMAIN: process.env.MAIN_DOMAIN
};
